import { Link, NavLink, Outlet } from "react-router-dom";
import { useAuth } from "../auth/AuthContext";

const linkBase =
  "px-3 py-2 text-sm rounded transition focus:outline-none focus-visible:ring-2 focus-visible:ring-signal";

export default function AppShell() {
  const { user, logout } = useAuth();

  return (
    <div className="min-h-dvh">
      <header className="border-b border-line">
        <div className="mx-auto flex max-w-5xl items-center gap-2 px-5 py-3">
          <Link
            to="/"
            className="mr-4 font-mono text-[11px] tracking-[0.18em] text-signal uppercase"
          >
            Garage Log
          </Link>

          <nav className="flex items-center gap-1">
            {[
              { to: "/", label: "Garage", end: true },
              { to: "/dashboard", label: "Dashboard" },
              { to: "/reports", label: "Reports" },
            ].map((item) => (
              <NavLink
                key={item.to}
                to={item.to}
                end={item.end}
                className={({ isActive }) =>
                  `${linkBase} ${isActive ? "bg-surface text-ink" : "text-ink-3 hover:text-ink"}`
                }
              >
                {item.label}
              </NavLink>
            ))}
          </nav>

          <div className="ml-auto flex items-center gap-3">
            <span className="hidden text-sm text-ink-3 sm:inline">
              {user?.name ?? user?.phone}
            </span>
            <button
              onClick={logout}
              className={`${linkBase} text-ink-3 hover:text-danger`}
            >
              Sign out
            </button>
          </div>
        </div>
      </header>

      <main className="mx-auto max-w-5xl px-5 py-8">
        <Outlet />
      </main>
    </div>
  );
}
